/* eslint eqeqeq: "off", curly: "error", @typescript-eslint/no-unused-vars: "off", react-hooks/exhaustive-deps: "off", array-callback-return: "off", no-eval: "off", jsx-a11y/alt-text: "off", jsx-a11y/anchor-is-valid: "off" */
import React, { useEffect, useState } from "react";
import ReactJson from "react-json-view";
import * as API from "../../http/api";
import { useHistory } from "react-router-dom";
import { useStyles } from "../../util/ComponentStyles";
import { FlexGrid, Typography, useThemeProvider, Card, Button } from "@albo-ui/core";
import { ErrorOutline, ContentPasteSearchOutlined } from "@mui/icons-material";
import { TextField } from "@mui/material";

const AqlDetail = (props) => {
    const { theme } = useThemeProvider();

    const history = useHistory();
    const clasess = useStyles();

    const [content, setContent] = useState(props.widgets[0].content);
    const [disabled, setDisabled] = useState(true);

    const [form, setForm] = useState({ aql: "" });
    const [error, setErrors] = useState({ aql: "" });

    useEffect(() => {
        if (props.next === "update") {
            props.updateNext(null);
        }
    }, [props.next]);

    const changeValue = (field, e) => {
        let f = form;
        let er = error;

        if (field) {
            f[field] = e.target.value;
            if (!e.target.value) {
                er[field] = "Dato obligatorio";
            } else {
                er[field] = "";
            }
        }

        setForm(JSON.parse(JSON.stringify(f)));
        setErrors(JSON.parse(JSON.stringify(er)));
        validateForm(f, er);
    };

    const validateForm = (f, err) => {
        if (f["aql"] && !err["aql"]) {
            setDisabled(false);
        } else {
            setDisabled(true);
        }
    };

    const send = async () => {
        props.changeLoader(true);
        let user = JSON.parse(localStorage.session);
        let data = form;
        data["agent"] = user["uuid"];

        let request = await API.service("alboQueryLanguaje", data, props.pos, props.changeAlert, props.changeLoader, history);
        if (request.status === 200 && request.data.data.response === "OK") {
            let widg = request.data.data.widget;
            setContent(widg);
        } else {
            let detail = request.data.data.message;
            props.changeAlert(true, "error", "Error al ejecutar la consulta: " + detail);
        }
        props.changeLoader(false);
    };

    return (
        <>
            <Card padding={3} fullWidth fullHeight style={{ borderColor: theme.colors.manatee, margin: 3, marginBottom: 15 }}>
                <FlexGrid container direction="column" spacing={2} fullWidth>
                    <FlexGrid container item fullWidth justify="space-between">
                        <Typography variant="h2" style={{display: "flex", alignItems: "center", fontSize: "1.4rem"}}>
                            <ContentPasteSearchOutlined sx={{ marginRight: 1 }} /> Consulta aql
                        </Typography>
                        <Button onClick={send.bind(this)} disabled={disabled} style={{ width: 100 }} size="normal">
                            Ejecutar
                        </Button>
                    </FlexGrid>

                    <FlexGrid item fullWidth>
                        <TextField
                            label="Comando" defaultValue={props.widgets[0].query} onChange={changeValue.bind(this, "aql")}
                            color={"secondary"} style={{ marginBottom: 10 }} size="small" fullWidth multiline rows={2}
                        />
                    </FlexGrid>
                </FlexGrid>
            </Card>
            <Card fullWidth fullHeight padding={3} flexDirection="column" alignItems="stretch" justifyContent="space-between" style={{ borderColor: theme.colors.manatee, margin: 3 }}>
                <FlexGrid container fullWidth>
                    <FlexGrid item fullWidth>
                        <Typography variant="h2" style={{display: "flex", alignItems: "center", fontSize: "1.4rem"}}>
                            <ErrorOutline sx={{ marginRight: 1 }} /> Detalle
                            consulta aql
                        </Typography>
                        <Typography
                            variant="paragraph"
                            children={
                                <div className={`size-12 top-line ${clasess.card_type2}`}>
                                    <ReactJson
                                        src={content}
                                        name="data"
                                        collapsed={false}
                                        displayDataTypes={false}
                                        style={{maxHeight: "500px", overflowY: "scroll"}}
                                    />
                                </div>
                            }
                            />
                    </FlexGrid>
                </FlexGrid>
            </Card>
        </>
    );
};

export default AqlDetail;
